module.exports = __webpack_public_path__ + "static/media/reversed_moblyx_no_strapline_blue_circle.4be9e4c1.png";